import app from 'flarum/forum/app';
import addFrontSort from './addFrontSort';
import addFrontToPosts from './addFrontToPosts';
import addFrontPage from './addFrontPage';
import addStickyBadge from './addStickyBadge';
import PushFrontedNotification from './components/PushFrontedNotification';
import PullFrontedNotification from './components/PullFrontedNotification';
import FrontFailedNotification from './components/FrontFailedNotification';
import PushFrontSuccessedNotification from './components/PushFrontSuccessedNotification';
import PushFrontToGuestSuccessedNotification from './components/PushFrontToGuestSuccessedNotification';
import PullFrontSuccessedNotification from './components/PullFrontSuccessedNotification';
import { extend } from 'flarum/common/extend';
import Post from 'flarum/common/models/Post';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
import NotificationGrid from 'flarum/forum/components/NotificationGrid';

app.initializers.add('fof/frontpage', () => {
  app.notificationComponents.pushFronted = PushFrontedNotification;
  app.notificationComponents.pullFronted = PullFrontedNotification;
  app.notificationComponents.frontFailed = FrontFailedNotification;
  app.notificationComponents.pushFrontSuccessed = PushFrontSuccessedNotification;
  app.notificationComponents.pullFrontSuccessed = PullFrontSuccessedNotification;
  app.notificationComponents.pushFrontToGuestSuccessed = PushFrontToGuestSuccessedNotification;
  addFrontSort();
  addFrontPage();
  addStickyBadge();
  addFrontToPosts();
  

  // extend(NotificationGrid.prototype, 'notificationTypes', function (items) {
  //   items.add('pushFronted', {
  //     name: 'pushFronted',
  //     icon: 'far fa-thumbs-up',
  //     label: app.translator.trans('dl_discussion_controller.forum.pushFrontModal.notify_post_push_label'),
  //   });
  
  // });

extend(PostControls, 'destructiveControls', function (items, post) {
    // if (!post.discussion().frontpage()) {
    //   items.add(
    //     'frontpage',
    //     <Button icon="fas fa-check" onclick={PostControls.frontpageAction.bind(post,true)}>
    //       {app.translator.trans('dl_discussion_controller.forum.pushFrontModal.success_front')}
    //     </Button>,
    //     10
    //   );

    //   items.add(
    //     'unfrontpage',
    //     <Button icon="fas fa-check" onclick={PostControls.frontpageAction.bind(post,false)}>
    //       {app.translator.trans('dl_discussion_controller.forum.pushFrontModal.fail_front')}
    //     </Button>,
    //     10
    //   );
    // }
  });

  // PostControls.frontpageAction = function (post,isfront) {
  //   this.discussion().save({ frontpage: isfront })
  //   // this.save({ isApproved: true });

  //   // if (this.number() === 1) {
  //   //   this.discussion().pushAttributes({ isApproved: true });
  //   // }
  // };
});
